import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import InnerLoading from '../ui/InnerLoading'
import { CiLocationOn } from 'react-icons/ci'
import { FaCalendarAlt, FaStar } from 'react-icons/fa'
import { fetchBookStays } from '../../features/home/bookingSlice'
import { formatDateRange, getStatusClass } from '../../utils/data'
import { Link } from 'react-router-dom'

const BookedStays = () => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { bookedStays, loading } = useSelector((state: RootState) => state.bookingSlice)
    const { user } = useSelector((state: RootState) => state.user)

    useEffect(() => {
        if (user?.id) {
            dispatch(fetchBookStays(user.id))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, user?.id])



    return (
        <>
        <h3 className='text-2xl font-semibold mb-4'>{t("my-bookings")}</h3>
            {loading ? (
                <InnerLoading />
            ) : bookedStays.length === 0 ? (
                <div className="flex-center flex-col gap-3">
                    <div className="w-52">
                        <img
                            src="/asset/no-books.png"
                            className="w-full"
                            alt="no-books"
                            loading="lazy"
                        />
                    </div>
                    <p className="text-textSecond">{t('no-stays')}</p>
                </div>
            ) : (
                <div className="grid gap-4 xs:grid-cols-1 md:grid-cols-2">
                    {bookedStays.map((stay, idx) => (
                        <Link
                            to={`/me/book-details/${stay.id}`}
                            key={idx}
                            className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white"
                        >
                            <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                                <img
                                    src={stay?.place?.images?.[0]?.url||"/asset/modern-commercial-building.webp"}
                                    alt={stay?.place?.title}
                                    className="w-full h-full object-cover"
                                    loading='lazy'
                                />
                                <span
                                    className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                        } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                                >
                                    {stay?.place?.subCategory?.title || stay?.place?.type}
                                </span>
                            </div>
                            <div className="flex flex-col justify-between flex-1 p-3">
                                <div className="border-b pb-2">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2 text-sm text-gray-600">
                                            <FaStar className="text-secondry" />
                                            {stay?.place?.rate?.toFixed(1)}{' '}
                                        </div>
                                        <span
                                            className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                                stay.state
                                            )}`}
                                        >
                                            {stay.state==="Pending"&&stay.paymentMethod==="Cash"?t("pending-cash") : t(`${stay.state.toLowerCase()}`) || stay.state}
                                        </span>
                                    </div>
                                    <h2 className="mt-1 text-lg font-bold">
                                        {stay?.place?.title}
                                    </h2>
                                    <p className="flex items-center gap-1 text-sm text-gray-500">
                                        <CiLocationOn /> {stay?.place?.location}
                                    </p>
                                    <p className="mt-1 text-lg font-semibold text-secondry">
                                        {stay?.price} {user?.currencyCode}
                                    </p>
                                </div>
                                <div className="flex-between pt-2 text-sm text-textSecond">
                                    <p className="flex items-center gap-1 text-darkColor font-medium">
                                        <FaCalendarAlt />
                                        <span>{t('dates')}</span>
                                    </p>
                                    <p>{formatDateRange(stay.checkIn, stay.checkOut)}</p>
                                </div>

                                
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </>
    )
}
export default BookedStays


